import { useSpeakerCreateAndSetPointMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const useSpeakerCreateAndSetPoint = () => {
  const [mutation, mutationResult] = useSpeakerCreateAndSetPointMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (pointId: string) => {
    const mutationResult = await mutation({ variables: { input: { pointId } } });
    return {
      ok: !!mutationResult.data?.speakerCreateAndSetPoint?.ok,
      data:
        (mutationResult.data &&
          mutationResult.data.speakerCreateAndSetPoint &&
          mutationResult.data.speakerCreateAndSetPoint?.smartSpeakerInfo) ??
        undefined,
    };
  };

  return {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    request,
  };
};

export default useSpeakerCreateAndSetPoint;
